import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import VueAxios from "vue-axios";
import Vuelidate from "vuelidate";
import VueCookies from "vue-cookies";

const moment = require("moment");
require("moment/locale/es");

Vue.use(require("vue-moment"), {
  moment,
});

Vue.use(VueCookies);
Vue.use(Vuelidate);

Vue.use(VueAxios, axios);
Vue.config.productionTip = false;

axios.defaults.baseURL =
  process.env.NODE_ENV == "development" 
    ? "http://192.168.2.228:3000/api"
    : "https://ciro.cayetanografica.com.ar/api";

// axios.defaults.baseURL = "https://ciro.cayetanografica.com.ar/api"

axios.interceptors.request.use(function(config) {
  if (store.state.token && !config.fiscal)
    config.headers.common["access-token"] = store.state.token
  return config;
});

axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (error.response.status === 401) {
      if (store.state.token) console.log("401")
      router.push("/login");
    }
    return Promise.reject(error);
  }
);

$cookies.config("1d", "/", "", true, "Strict");

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
